export { default } from './RegisterPage'
